const Pages = Object.freeze({
  PGR_LIST: "pgr-list",
  PGR_NEW_COMPLAINT: "pgr-new-complaint",
  PGR_SEARCH: "pgr-search-complaint",
});

export default Pages;
